module.exports = __webpack_public_path__ + "1c0c0a5dbe7b298014ef89fc98060376.png";